(function () {
  var body = document.body;
  var pendingDeleteId = null;
  var deleteOverlay = document.querySelector("[data-delete-confirm-overlay]");
  var deleteText = document.querySelector("[data-delete-confirm-vehicle]");
  var editOverlay = document.querySelector("[data-edit-vehicle-overlay]");
  var vehicleLimitOverlay = document.querySelector("[data-vehicle-limit-overlay]");
  var vehicleSavedOverlay = document.querySelector("[data-vehicle-saved-overlay]");
  var vehicleSavedActiveOverlay = document.querySelector("[data-vehicle-saved-active-overlay]");
  var visualSearchOverlay = document.querySelector("[data-visual-search-overlay]");
  var visualAbortController = null;
  var visualObjectUrl = "";
  var visualOpener = null;
  var visualRequestSequence = 0;
  var pendingEditId = null;
  var pendingActiveVehicleId = null;
  var activePopupVehicles = [];
  var GARAGE_DEPENDENT_OVERLAY_SELECTOR = [
    "[data-registration-overlay]",
    "[data-order-success-overlay]",
    "[data-size-detect-overlay]",
    "[data-delete-confirm-overlay]",
    "[data-edit-vehicle-overlay]",
    "[data-vehicle-limit-overlay]",
    "[data-vehicle-saved-overlay]",
    "[data-vehicle-saved-active-overlay]"
  ].join(", ");

  function escapeHtml(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function garagePageHref() {
    return window.KOLAYOTO_GARAGE_PAGE_URL || "/pages/garajim";
  }

  function setDeleteVehicleText(detail) {
    if (!deleteText) return;

    var title = detail && detail.title ? String(detail.title) : "Seçili araç";
    var spec = detail && detail.spec ? String(detail.spec) : "";

    deleteText.innerHTML = '<span class="delete-confirm-vehicle-title">' + escapeHtml(title) + '</span>' +
      (spec ? '<span class="delete-confirm-vehicle-spec">' + escapeHtml(spec) + '</span>' : "");
  }

  function setLoadingButton(button, isLoading, loadingText) {
    if (!button) return;

    if (isLoading) {
      if (!button.dataset.originalLabel) {
        button.dataset.originalLabel = button.textContent.trim();
      }
      button.classList.add("is-loading");
      button.disabled = true;
      button.setAttribute("aria-busy", "true");
      button.innerHTML = '<span>' + escapeHtml(loadingText || "Yükleniyor") + '</span>';
      return;
    }

    button.classList.remove("is-loading");
    button.disabled = false;
    button.removeAttribute("aria-busy");
    if (button.dataset.originalLabel) {
      button.textContent = button.dataset.originalLabel;
      delete button.dataset.originalLabel;
    }
  }

  function digitsOnly(value, maxLength) {
    var digits = String(value || "").replace(/\D/g, "");
    return maxLength ? digits.slice(0, maxLength) : digits;
  }

  function syncBodyLock() {
    var hasOpenOverlay = document.querySelector(".registration-overlay.is-open");
    body.classList.toggle("registration-modal-open", Boolean(hasOpenOverlay));
  }

  function isGarageApiAvailable() {
    return Boolean(window.GarageModal && typeof window.GarageModal.isAvailable === "function" && window.GarageModal.isAvailable());
  }

  function closeGarageOverlays() {
    document.querySelectorAll(GARAGE_DEPENDENT_OVERLAY_SELECTOR).forEach(function (overlay) {
      if (!overlay.classList.contains("is-open")) return;
      closeOverlay(overlay);
    });
  }

  function isGarageDependentOverlay(overlay) {
    return Boolean(overlay && overlay.matches(GARAGE_DEPENDENT_OVERLAY_SELECTOR));
  }

  function openOverlay(overlay) {
    if (!overlay) return;
    if (isGarageDependentOverlay(overlay) && !isGarageApiAvailable()) return;
    document.querySelectorAll(".registration-overlay.is-open").forEach(function (item) {
      if (item !== overlay) {
        closeOverlay(item);
      }
    });
    overlay.classList.add("is-open");
    overlay.setAttribute("aria-hidden", "false");
    syncBodyLock();
  }

  function closeOverlay(overlay) {
    if (!overlay) return;
    if (overlay === visualSearchOverlay) {
      visualRequestSequence += 1;
      if (visualAbortController) {
        visualAbortController.abort();
        visualAbortController = null;
      }
      if (visualObjectUrl && window.URL && typeof window.URL.revokeObjectURL === "function") {
        window.URL.revokeObjectURL(visualObjectUrl);
        visualObjectUrl = "";
      }
    }
    overlay.classList.remove("is-open");
    overlay.setAttribute("aria-hidden", "true");
    syncBodyLock();
    if (overlay === visualSearchOverlay && visualOpener) {
      var openerToFocus = visualOpener;
      visualOpener = null;
      window.setTimeout(function () {
        if (document.contains(openerToFocus)) openerToFocus.focus();
      }, 0);
    }
  }

  function openGarageFlow() {
    if (!isGarageApiAvailable()) return;
    if (window.GarageModal && typeof window.GarageModal.open === "function") {
      window.GarageModal.open();
      return;
    }

    var garageFlowOpener = document.querySelector("[data-garage-open-flow]");
    if (garageFlowOpener) {
      garageFlowOpener.click();
      return;
    }

    var garageModalOpener = document.querySelector("[data-garage-add-vehicle]");
    if (garageModalOpener) {
      garageModalOpener.click();
    }
  }

  function bindModal(config) {
    var overlay = document.querySelector(config.overlay);
    if (!overlay) return;

    var openers = document.querySelectorAll(config.openers);
    var primaryButton = overlay.querySelector(config.primaryButton);
    var skipButton = overlay.querySelector(config.skipButton);
    var secondaryButton = config.secondaryButton ? overlay.querySelector(config.secondaryButton) : null;

    openers.forEach(function (opener) {
      opener.addEventListener("click", function () {
        openOverlay(overlay);
      });
    });

    overlay.addEventListener("click", function (event) {
      if (event.target === overlay) {
        closeOverlay(overlay);
      }
    });

    if (skipButton) {
      skipButton.addEventListener("click", function () {
        closeOverlay(overlay);
        if (config.skipEvent) {
          document.dispatchEvent(new CustomEvent(config.skipEvent));
        }
      });
    }

    if (primaryButton) {
      primaryButton.addEventListener("click", function () {
        closeOverlay(overlay);
        if (config.primaryEvent) {
          document.dispatchEvent(new CustomEvent(config.primaryEvent));
        }
        openGarageFlow();
      });
    }

    if (secondaryButton && config.secondaryEvent) {
      secondaryButton.addEventListener("click", function () {
        document.dispatchEvent(new CustomEvent(config.secondaryEvent));
      });
    }
  }

  bindModal({
    overlay: "[data-registration-overlay]",
    openers: "[data-registration-open]",
    primaryButton: "[data-registration-add-vehicle]",
    skipButton: "[data-registration-skip]",
    primaryEvent: "registration:add-vehicle",
    skipEvent: "registration:skip"
  });

  bindModal({
    overlay: "[data-order-success-overlay]",
    openers: "[data-order-success-open]",
    primaryButton: "[data-order-link-vehicle]",
    skipButton: "[data-order-success-skip]",
    primaryEvent: "order-success:link-vehicle",
    skipEvent: "order-success:skip"
  });

  bindModal({
    overlay: "[data-size-detect-overlay]",
    openers: "[data-size-detect-open]",
    primaryButton: "[data-size-detect-add-vehicle]",
    skipButton: "[data-size-detect-skip]",
    secondaryButton: "[data-size-detect-show-products]",
    primaryEvent: "size-detect:add-vehicle",
    secondaryEvent: "size-detect:show-products",
    skipEvent: "size-detect:skip"
  });

  if (visualSearchOverlay) {
    var visualStates = visualSearchOverlay.querySelectorAll("[data-visual-search-state]");
    var visualFileInputs = visualSearchOverlay.querySelectorAll("[data-visual-search-file]");
    var visualCameraFileInput = visualSearchOverlay.querySelector('[data-visual-search-file="camera"]');
    var visualDeviceFileInput = visualSearchOverlay.querySelector('[data-visual-search-file="device"]');
    var visualCloseButton = visualSearchOverlay.querySelector("[data-visual-search-close]");
    var visualTitleCameraIcon = visualSearchOverlay.querySelector("[data-visual-search-title-camera-icon]");
    var visualTitleSuccessIcon = visualSearchOverlay.querySelector("[data-visual-search-title-success-icon]");
    var visualTitleLabel = visualSearchOverlay.querySelector("[data-visual-search-title-label]");
    var visualWidthInput = visualSearchOverlay.querySelector("[data-visual-result-width]");
    var visualHeightInput = visualSearchOverlay.querySelector("[data-visual-result-height]");
    var visualRimInput = visualSearchOverlay.querySelector("[data-visual-result-rim]");
    var visualSubmitButton = visualSearchOverlay.querySelector("[data-visual-result-products]");
    var visualSubmitLabel = visualSearchOverlay.querySelector("[data-visual-result-submit-label]");
    var visualProcessingThumb = visualSearchOverlay.querySelector("[data-visual-processing-thumb]");
    var visualResultThumb = visualSearchOverlay.querySelector("[data-visual-result-thumb]");
    var visualResultFileMeta = visualSearchOverlay.querySelector("[data-visual-result-file-meta]");
    var visualResultDetected = visualSearchOverlay.querySelector(".visual-result-detected");
    var visualResultStatusIcon = visualSearchOverlay.querySelector(".visual-result-status-icon");
    var visualResultHeading = visualSearchOverlay.querySelector("[data-visual-result-heading]");
    var visualResultDescription = visualSearchOverlay.querySelector("[data-visual-result-description]");
    var visualErrorMessage = visualSearchOverlay.querySelector("[data-visual-search-error-message]");

    function setVisualState(state) {
      var visibleState = state === "manual" ? "result" : state;
      visualStates.forEach(function (item) {
        item.hidden = item.getAttribute("data-visual-search-state") !== visibleState;
      });

      var isResult = state === "result";
      var isManual = state === "manual";
      if (visualTitleCameraIcon) visualTitleCameraIcon.toggleAttribute("hidden", isResult);
      if (visualTitleSuccessIcon) visualTitleSuccessIcon.toggleAttribute("hidden", !isResult);
      if (visualTitleLabel) visualTitleLabel.textContent = isResult ? "Ebat Tespit Edildi" : (isManual ? "Manuel Ebat Gir" : "Görselle Lastik Ara");
      if (visualResultDetected) visualResultDetected.classList.toggle("is-manual", isManual);
      if (visualResultStatusIcon) visualResultStatusIcon.toggleAttribute("hidden", isManual);
      if (visualResultHeading) visualResultHeading.textContent = isManual ? "Lastik ebadını manuel girin" : "Lastik ebatınızı tespit ettik";
      if (visualResultDescription) visualResultDescription.textContent = isManual ? "Genişlik, yükseklik ve jant çapı değerlerini doldurun." : "Aşağıdaki değerleri kontrol edin. Yanlışsa tıklayıp düzeltebilirsiniz.";
    }

    function resetVisualUpload() {
      visualRequestSequence += 1;
      if (visualAbortController) {
        visualAbortController.abort();
        visualAbortController = null;
      }
      if (visualObjectUrl && window.URL && typeof window.URL.revokeObjectURL === "function") {
        window.URL.revokeObjectURL(visualObjectUrl);
        visualObjectUrl = "";
      }
      visualFileInputs.forEach(function (input) {
        input.value = "";
      });
      if (visualProcessingThumb) visualProcessingThumb.removeAttribute("src");
      if (visualResultThumb) visualResultThumb.removeAttribute("src");
      if (visualResultFileMeta) visualResultFileMeta.textContent = "";
      if (visualWidthInput) visualWidthInput.value = "";
      if (visualHeightInput) visualHeightInput.value = "";
      if (visualRimInput) visualRimInput.value = "";
      setVisualState("upload");
      syncVisualTireSize();
    }

    function getVisualTireSize() {
      syncVisualTireSize();
      var width = visualWidthInput ? visualWidthInput.value : "";
      var height = visualHeightInput ? visualHeightInput.value : "";
      var rim = visualRimInput ? visualRimInput.value : "";

      if (!/^\d{3}$/.test(width) || !/^\d{2}$/.test(height) || !/^\d{2}$/.test(rim)) {
        return "";
      }

      return width + "/" + height + "R" + rim;
    }

    function syncVisualTireSize() {
      if (visualWidthInput) visualWidthInput.value = digitsOnly(visualWidthInput.value, 3);
      if (visualHeightInput) visualHeightInput.value = digitsOnly(visualHeightInput.value, 2);
      if (visualRimInput) visualRimInput.value = digitsOnly(visualRimInput.value, 2);

      var width = visualWidthInput ? visualWidthInput.value : "";
      var height = visualHeightInput ? visualHeightInput.value : "";
      var rim = visualRimInput ? visualRimInput.value : "";
      var isComplete = /^\d{3}$/.test(width) && /^\d{2}$/.test(height) && /^\d{2}$/.test(rim);
      var label = isComplete ? width + "/" + height + "R" + rim + " lastiklerini ara" : "Ebat bilgilerini tamamlayın";

      if (visualSubmitLabel) visualSubmitLabel.textContent = label;
      if (visualSubmitButton) visualSubmitButton.disabled = !isComplete;
    }

    function formatVisualFileSize(bytes) {
      if (bytes >= 1024 * 1024) return (bytes / (1024 * 1024)).toFixed(1) + " MB";
      return Math.max(1, Math.round(bytes / 1024)) + " KB";
    }

    function visualErrorText(code) {
      if (code === "invalid_type") return "Yalnızca JPG veya PNG formatında bir görsel yükleyebilirsiniz.";
      if (code === "invalid_size") return "Görsel boyutu en fazla 10 MB olabilir.";
      if (code === "invalid_upload") return "Geçerli bir JPG veya PNG görseli yükleyin (en fazla 10 MB).";
      if (code === "unsupported_content") return "Görselde bir lastik yan yüzeyi bulamadık. Ebat yazıları görünecek şekilde yeniden çekin.";
      if (code === "tire_size_not_detected") return "Ebat yazıları yeterince net görünmüyor. Daha aydınlık ve yakın bir fotoğraf deneyin.";
      if (code === "rate_limited") return "Çok fazla deneme yapıldı. Kısa süre bekleyip yeniden deneyin.";
      return "Görsel şu anda analiz edilemiyor. Lütfen biraz sonra tekrar deneyin.";
    }

    function showVisualError(code) {
      if (visualErrorMessage) visualErrorMessage.textContent = visualErrorText(code);
      setVisualState("error");
    }

    function setVisualFilePreview(file) {
      if (visualObjectUrl && window.URL && typeof window.URL.revokeObjectURL === "function") {
        window.URL.revokeObjectURL(visualObjectUrl);
        visualObjectUrl = "";
      }

      if (!window.URL || typeof window.URL.createObjectURL !== "function") return;

      visualObjectUrl = window.URL.createObjectURL(file);
      if (visualProcessingThumb) visualProcessingThumb.src = visualObjectUrl;
      if (visualResultThumb) visualResultThumb.src = visualObjectUrl;
      if (visualResultFileMeta) visualResultFileMeta.textContent = file.name + " · " + formatVisualFileSize(file.size);
    }

    function showVisualResult(data, file) {
      var result = data && data.data ? data.data : {};
      if (visualWidthInput) visualWidthInput.value = digitsOnly(result.width, 3);
      if (visualHeightInput) visualHeightInput.value = digitsOnly(result.aspect_ratio, 2);
      if (visualRimInput) visualRimInput.value = digitsOnly(result.rim_diameter, 2);

      syncVisualTireSize();
      setVisualState("result");
    }

    function visualSearchEndpoint() {
      var base = String(window.KOLAYOTO_GARAGE_PROXY_URL || "/apps/garage-dev").replace(/\/$/, "");
      return base + "/visual-tire-search";
    }

    function analyzeVisualFile(file) {
      if (!file) return;
      var hasSupportedType = ["image/jpeg", "image/png"].indexOf(file.type) > -1;
      var hasSupportedExtension = /\.(jpe?g|png)$/i.test(file.name || "");
      if (!hasSupportedType && !(file.type === "" && hasSupportedExtension)) {
        showVisualError("invalid_type");
        return;
      }
      if (file.size > 10 * 1024 * 1024) {
        showVisualError("invalid_size");
        return;
      }
      if (typeof window.fetch !== "function" || typeof window.FormData !== "function") {
        showVisualError("analysis_unavailable");
        return;
      }

      visualRequestSequence += 1;
      var requestSequence = visualRequestSequence;
      if (visualAbortController) visualAbortController.abort();
      visualAbortController = window.AbortController ? new AbortController() : null;
      setVisualFilePreview(file);

      var formData = new FormData();
      formData.append("image", file, file.name);
      var requestOptions = {
        method: "POST",
        body: formData,
        cache: "no-store",
        credentials: "same-origin",
        headers: { "Accept": "application/json" }
      };
      if (visualAbortController) requestOptions.signal = visualAbortController.signal;

      setVisualState("processing");

      window.fetch(visualSearchEndpoint(), requestOptions)
        .then(function (response) {
          return response.text().then(function (text) {
            var data = null;
            try {
              data = text ? JSON.parse(text) : null;
            } catch (error) {
              data = null;
            }

            if (!response.ok || !data || data.success !== true) {
              var requestError = new Error("Visual tire search failed");
              requestError.status = response.status;
              requestError.code = data && data.error ? data.error.code : "analysis_unavailable";
              throw requestError;
            }

            return data;
          });
        })
        .then(function (data) {
          if (requestSequence !== visualRequestSequence) return;
          visualAbortController = null;
          showVisualResult(data, file);
        })
        .catch(function (error) {
          if (requestSequence !== visualRequestSequence || (error && error.name === "AbortError")) return;
          visualAbortController = null;
          showVisualError(error && error.code ? error.code : "analysis_unavailable");
        });
    }

    function openVisualSearch(opener) {
      visualOpener = opener || null;
      resetVisualUpload();
      openOverlay(visualSearchOverlay);
      window.setTimeout(function () {
        if (visualCloseButton) visualCloseButton.focus();
      }, 0);
    }

    function chooseAnotherVisualFile() {
      resetVisualUpload();
      if (visualDeviceFileInput) visualDeviceFileInput.click();
    }

    function openManualTireSearch() {
      if (visualWidthInput) visualWidthInput.value = "";
      if (visualHeightInput) visualHeightInput.value = "";
      if (visualRimInput) visualRimInput.value = "";
      syncVisualTireSize();
      setVisualState("manual");

      window.setTimeout(function () {
        if (visualWidthInput) visualWidthInput.focus();
      }, 0);
    }

    function visualSearchFallbackHref(tireSize) {
      var params = new URLSearchParams();
      params.set("type", "product");
      params.set("options[unavailable_products]", "last");
      params.set("options[prefix]", "none");
      params.set("filter.v.availability", "1");
      params.set("q", tireSize + "*");
      params.set("filter.p.m.filtre.ebat", tireSize);
      params.set("sort_by", "price-ascending");

      return "/search?" + params.toString();
    }

    function visualSearchCollectionHref(tireSize) {
      var normalized = String(tireSize || "").toUpperCase().replace(/\s+/g, "");
      var parts = normalized.match(/^(\d{2,3})\/(\d{2})R(\d{2})$/);

      if (!parts) return "";

      return "/collections/" + parts[1] + "-" + parts[2] + "-r" + parts[3] + "-lastikleri";
    }

    function visualProductsHref(tireSize) {
      var fallbackHref = visualSearchFallbackHref(tireSize);
      var collectionHref = visualSearchCollectionHref(tireSize);

      if (!collectionHref || typeof window.fetch !== "function") {
        return Promise.resolve(fallbackHref);
      }

      var controller = typeof window.AbortController === "function" ? new window.AbortController() : null;
      var timeoutId = window.setTimeout(function () {
        if (controller) controller.abort();
      }, 4000);

      return window.fetch(collectionHref, {
        method: "HEAD",
        cache: "no-store",
        credentials: "same-origin",
        signal: controller ? controller.signal : undefined
      }).then(function (response) {
        return response.ok && !response.redirected ? collectionHref : fallbackHref;
      }).catch(function () {
        return fallbackHref;
      }).finally(function () {
        window.clearTimeout(timeoutId);
      });
    }

    document.querySelectorAll("[data-visual-search-open]").forEach(function (opener) {
      opener.addEventListener("click", function (event) {
        event.preventDefault();
        openVisualSearch(opener);
      });
    });

    visualSearchOverlay.addEventListener("click", function (event) {
      if (event.target.closest("[data-visual-search-camera]")) {
        if (visualCameraFileInput) {
          visualCameraFileInput.value = "";
          visualCameraFileInput.click();
        }
        return;
      }

      if (event.target.closest("[data-visual-search-device]")) {
        if (visualDeviceFileInput) {
          visualDeviceFileInput.value = "";
          visualDeviceFileInput.click();
        }
        return;
      }

      if (event.target === visualSearchOverlay || event.target.closest("[data-visual-search-close], [data-visual-result-cancel]")) {
        closeOverlay(visualSearchOverlay);
        return;
      }

      if (event.target.closest("[data-visual-search-reupload], [data-visual-search-retry]")) {
        chooseAnotherVisualFile();
        return;
      }

      if (event.target.closest("[data-visual-search-manual]")) {
        openManualTireSearch();
        return;
      }

      if (event.target.closest("[data-visual-result-products]")) {
        var tireSize = getVisualTireSize();
        if (!tireSize) return;
        document.dispatchEvent(new CustomEvent("visual-search:show-products", {
          detail: { tireSize: tireSize }
        }));
        visualProductsHref(tireSize).then(function (href) {
          window.location.assign(href);
        });
      }
    });

    visualSearchOverlay.addEventListener("change", function (event) {
      if (!event.target.matches("[data-visual-search-file]")) return;
      analyzeVisualFile(event.target.files && event.target.files[0]);
    });

    visualSearchOverlay.addEventListener("input", function (event) {
      if (!event.target.matches("[data-visual-result-width], [data-visual-result-height], [data-visual-result-rim]")) return;
      syncVisualTireSize();
    });

    resetVisualUpload();
  }

  if (deleteOverlay) {
    var deleteApprove = deleteOverlay.querySelector("[data-delete-confirm-approve]");
    var deleteCancel = deleteOverlay.querySelector("[data-delete-confirm-cancel]");
    var deleteClose = deleteOverlay.querySelector("[data-delete-confirm-close]");

    function setDeleteLoading(isLoading) {
      deleteOverlay.classList.toggle("is-loading", Boolean(isLoading));
      setLoadingButton(deleteApprove, isLoading, "Siliniyor");
      if (deleteCancel) deleteCancel.disabled = Boolean(isLoading);
      if (deleteClose) deleteClose.disabled = Boolean(isLoading);
    }

    document.querySelectorAll("[data-delete-confirm-open]").forEach(function (opener) {
      opener.addEventListener("click", function () {
        pendingDeleteId = null;
        setDeleteLoading(false);
        setDeleteVehicleText({ title: "Toyota Yaris", spec: "2023 · 34 ABC 48" });
        openOverlay(deleteOverlay);
      });
    });

    deleteOverlay.addEventListener("click", function (event) {
      if (deleteOverlay.classList.contains("is-loading")) {
        if (event.target === deleteOverlay || event.target.closest("[data-delete-confirm-close], [data-delete-confirm-cancel], [data-delete-confirm-approve]")) return;
      }

      if (event.target === deleteOverlay || event.target.closest("[data-delete-confirm-close]")) {
        closeOverlay(deleteOverlay);
        return;
      }

      if (event.target.closest("[data-delete-confirm-cancel]")) {
        closeOverlay(deleteOverlay);
        document.dispatchEvent(new CustomEvent("garage:delete-cancelled"));
        return;
      }

      if (event.target.closest("[data-delete-confirm-approve]")) {
        if (pendingDeleteId) {
          setDeleteLoading(true);
          document.dispatchEvent(new CustomEvent("garage:confirm-delete", {
            detail: { id: pendingDeleteId }
          }));
          return;
        }
        closeOverlay(deleteOverlay);
      }
    });

    document.addEventListener("garage:request-delete", function (event) {
      var detail = event.detail || {};
      pendingDeleteId = detail.id || null;
      setDeleteLoading(false);
      setDeleteVehicleText(detail);
      openOverlay(deleteOverlay);
    });

    document.addEventListener("garage:delete-finished", function (event) {
      var detail = event.detail || {};
      if (pendingDeleteId && String(detail.id || "") !== String(pendingDeleteId)) return;
      setDeleteLoading(false);
      pendingDeleteId = null;
      closeOverlay(deleteOverlay);
    });

    document.addEventListener("garage:delete-failed", function (event) {
      var detail = event.detail || {};
      if (pendingDeleteId && String(detail.id || "") !== String(pendingDeleteId)) return;
      setDeleteLoading(false);
    });
  }

  if (editOverlay) {
    var editName = editOverlay.querySelector("[data-edit-vehicle-name]");
    var editSpec = editOverlay.querySelector("[data-edit-vehicle-spec]");
    var editNickname = editOverlay.querySelector("[data-edit-vehicle-nickname]");
    var editPlate = editOverlay.querySelector("[data-edit-vehicle-plate]");
    var editKm = editOverlay.querySelector("[data-edit-vehicle-km]");
    var editLastChange = editOverlay.querySelector("[data-edit-vehicle-last-change]");
    var editSave = editOverlay.querySelector("[data-edit-vehicle-save]");
    var editCancel = editOverlay.querySelector("[data-edit-vehicle-cancel]");
    var editClose = editOverlay.querySelector("[data-edit-vehicle-close]");
    var editFields = [editNickname, editPlate, editKm, editLastChange].filter(Boolean);

    function setEditLoading(isLoading) {
      editOverlay.classList.toggle("is-loading", Boolean(isLoading));
      setLoadingButton(editSave, isLoading, "Kaydediliyor");
      if (editCancel) editCancel.disabled = Boolean(isLoading);
      if (editClose) editClose.disabled = Boolean(isLoading);
      editFields.forEach(function (field) {
        field.disabled = Boolean(isLoading);
      });
    }

    function formatPlate(value) {
      var clean = String(value || "").toUpperCase().replace(/[^0-9A-Z]/g, "").slice(0, 9);
      var provinceMatch = clean.match(/^\d{0,2}/);
      var province = provinceMatch ? provinceMatch[0] : "";
      var rest = clean.slice(province.length);
      var letterMatch = rest.match(/^[A-Z]{0,3}/);
      var letters = letterMatch ? letterMatch[0] : "";
      var serial = rest.slice(letters.length).replace(/\D/g, "").slice(0, 4);
      return [province, letters, serial].filter(Boolean).join(" ");
    }

    function formatKm(value) {
      var digits = digitsOnly(value, 9);
      return digits.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }

    function numericKm(value) {
      return digitsOnly(value, 9);
    }

    function syncDatePlaceholder() {
      if (!editLastChange) return;
      editLastChange.classList.toggle("has-value", Boolean(editLastChange.value));
    }

    function applyEditMasks() {
      if (editPlate) editPlate.value = formatPlate(editPlate.value);
      if (editKm) editKm.value = formatKm(editKm.value);
      syncDatePlaceholder();
    }

    function fillEditFields(detail) {
      if (!detail) detail = {};
      if (editName) editName.textContent = detail.title || "Toyota Yaris";
      if (editSpec) editSpec.textContent = detail.spec || "2023 · 1.5 Hybrid · 185/65R15";
      if (editNickname) editNickname.value = detail.nickname || "";
      if (editPlate) editPlate.value = formatPlate(detail.plate || "");
      if (editKm) editKm.value = formatKm(detail.km || "");
      if (editLastChange) editLastChange.value = detail.lastTireChange || "";
      syncDatePlaceholder();
    }

    if (editPlate) {
      editPlate.addEventListener("input", function () {
        editPlate.value = formatPlate(editPlate.value);
      });
    }

    if (editKm) {
      editKm.addEventListener("input", function () {
        editKm.value = formatKm(editKm.value);
      });
    }

    if (editLastChange) {
      editLastChange.addEventListener("input", syncDatePlaceholder);
      editLastChange.addEventListener("change", syncDatePlaceholder);
    }

    document.querySelectorAll("[data-edit-vehicle-open]").forEach(function (opener) {
      opener.addEventListener("click", function () {
        pendingEditId = "vehicle-toyota-yaris";
        setEditLoading(false);
        fillEditFields({
          title: "Toyota Yaris",
          spec: "2023 · 1.5 Hybrid · 185/65R15",
          nickname: "Aile aracı",
          plate: "34 ABC 48",
          km: "42.320",
          lastTireChange: ""
        });
        openOverlay(editOverlay);
      });
    });

    editOverlay.addEventListener("click", function (event) {
      if (editOverlay.classList.contains("is-loading")) {
        if (event.target === editOverlay || event.target.closest("[data-edit-vehicle-close], [data-edit-vehicle-cancel], [data-edit-vehicle-save]")) return;
      }

      if (event.target === editOverlay || event.target.closest("[data-edit-vehicle-close]")) {
        closeOverlay(editOverlay);
        return;
      }
      if (event.target.closest("[data-edit-vehicle-cancel]")) {
        closeOverlay(editOverlay);
        document.dispatchEvent(new CustomEvent("garage:edit-cancelled"));
        return;
      }
      if (event.target.closest("[data-edit-vehicle-save]")) {
        if (!pendingEditId) {
          closeOverlay(editOverlay);
          return;
        }
        setEditLoading(true);
        document.dispatchEvent(new CustomEvent("garage:confirm-edit", {
          detail: {
            id: pendingEditId,
            nickname: editNickname ? editNickname.value.trim() : "",
            plate: editPlate ? formatPlate(editPlate.value).trim() : "",
            km: editKm ? numericKm(editKm.value) : "",
            lastTireChange: editLastChange ? editLastChange.value.trim() : ""
          }
        }));
      }
    });

    document.addEventListener("garage:request-edit", function (event) {
      var detail = event.detail || {};
      pendingEditId = detail.id || null;
      setEditLoading(false);
      fillEditFields(detail);
      applyEditMasks();
      openOverlay(editOverlay);
    });

    document.addEventListener("garage:edit-finished", function (event) {
      var detail = event.detail || {};
      if (pendingEditId && String(detail.id || "") !== String(pendingEditId)) return;
      setEditLoading(false);
      pendingEditId = null;
      closeOverlay(editOverlay);
    });

    document.addEventListener("garage:edit-failed", function (event) {
      var detail = event.detail || {};
      if (pendingEditId && String(detail.id || "") !== String(pendingEditId)) return;
      setEditLoading(false);
    });
  }

  if (vehicleLimitOverlay) {
    document.querySelectorAll("[data-vehicle-limit-open]").forEach(function (opener) {
      opener.addEventListener("click", function () {
        openOverlay(vehicleLimitOverlay);
      });
    });

    vehicleLimitOverlay.addEventListener("click", function (event) {
      if (event.target === vehicleLimitOverlay || event.target.closest("[data-vehicle-limit-close]")) {
        closeOverlay(vehicleLimitOverlay);
        return;
      }

      if (event.target.closest("[data-vehicle-limit-go-garage]")) {
        closeOverlay(vehicleLimitOverlay);
        window.location.href = garagePageHref();
      }
    });

    document.addEventListener("garage:vehicle-limit-reached", function () {
      openOverlay(vehicleLimitOverlay);
    });
  }

  if (vehicleSavedOverlay) {
    var vehicleSavedName = vehicleSavedOverlay.querySelector("[data-vehicle-saved-name]");
    var vehicleSavedSpec = vehicleSavedOverlay.querySelector("[data-vehicle-saved-spec]");

    function fillSavedVehicle(detail) {
      var data = detail || {};
      var name = data.title || "";
      if (!name && data.brand && data.model) {
        name = data.brand + " " + data.model;
      }
      if (!name) {
        name = "Toyota Yaris";
      }

      var engineName = "";
      var tire = "";
      if (data.engine && typeof data.engine === "object") {
        engineName = (data.engine.name || "").replace(/\s*\([^)]*\)/, "").trim();
        tire = data.engine.tire || "";
      } else {
        engineName = data.engineName || data.engine || "";
        tire = data.tire || "";
      }
      var spec = [data.year || "", engineName || "", tire || ""].filter(Boolean).join(" · ");
      if (!spec) {
        spec = "2023 · 1.5 Hybrid · 185/65R15";
      }

      if (vehicleSavedName) vehicleSavedName.textContent = name;
      if (vehicleSavedSpec) vehicleSavedSpec.textContent = spec;
    }

    document.querySelectorAll("[data-vehicle-saved-open]").forEach(function (opener) {
      opener.addEventListener("click", function () {
        fillSavedVehicle();
        openOverlay(vehicleSavedOverlay);
      });
    });

    vehicleSavedOverlay.addEventListener("click", function (event) {
      if (event.target === vehicleSavedOverlay || event.target.closest("[data-vehicle-saved-close]")) {
        closeOverlay(vehicleSavedOverlay);
        return;
      }

      if (event.target.closest("[data-vehicle-saved-products]")) {
        closeOverlay(vehicleSavedOverlay);
        document.dispatchEvent(new CustomEvent("garage:saved-show-products"));
        return;
      }

      if (event.target.closest("[data-vehicle-saved-add-another]")) {
        closeOverlay(vehicleSavedOverlay);
        openGarageFlow();
        return;
      }

      if (event.target.closest("[data-vehicle-saved-go-garage]")) {
        closeOverlay(vehicleSavedOverlay);
        window.location.href = garagePageHref();
      }
    });

    document.addEventListener("garage:vehicle-saved", function (event) {
      var detail = event.detail || {};
      var vehicleCount = Number(detail.totalVehicles || 0);
      if (vehicleSavedActiveOverlay && vehicleCount > 1) {
        return;
      }
      fillSavedVehicle(detail);
      openOverlay(vehicleSavedOverlay);
    });
  }

  if (vehicleSavedActiveOverlay) {
    var activeAddedEl = vehicleSavedActiveOverlay.querySelector("[data-vehicle-saved-active-added]");
    var activeSpecEl = vehicleSavedActiveOverlay.querySelector("[data-vehicle-saved-active-spec]");
    var activeCountEl = vehicleSavedActiveOverlay.querySelector("[data-vehicle-saved-active-count]");
    var activeOptionsEl = vehicleSavedActiveOverlay.querySelector("[data-vehicle-saved-active-options]");

    function normalizeVehicleLabel(vehicle) {
      if (!vehicle) return "";
      return vehicle.nickname || ((vehicle.brand || "") + " " + (vehicle.model || "")).trim();
    }

    function normalizeVehicleMakeModel(vehicle) {
      if (!vehicle) return "";
      return ((vehicle.brand || "") + " " + (vehicle.model || "")).trim();
    }

    function normalizeVehicleSpec(vehicle) {
      if (!vehicle) return "";
      return [vehicle.year || "", vehicle.engineName || "", vehicle.tire || ""].filter(Boolean).join(" · ");
    }

    function renderSavedActiveOptions() {
      if (!activeOptionsEl) return;
      activeOptionsEl.classList.toggle("is-scroll", activePopupVehicles.length > 4);
      activeOptionsEl.innerHTML = activePopupVehicles.map(function (vehicle) {
        var isSelected = vehicle.id === pendingActiveVehicleId;
        var isNew = vehicle.id === (vehicleSavedActiveOverlay.getAttribute("data-new-vehicle-id") || "");
        var stateLabel = isSelected ? "Aktif" : "Seç";
        var makeModel = normalizeVehicleMakeModel(vehicle);
        var hasNickname = Boolean(vehicle.nickname);
        return '' +
          '<button class="vehicle-saved-active-option ' + (isSelected ? "is-selected" : "") + '" type="button" data-vehicle-saved-active-pick="' + vehicle.id + '">' +
            '<span class="vehicle-saved-active-option-name">' +
              escapeHtml(normalizeVehicleLabel(vehicle)) + (isNew ? ' <span>(yeni)</span>' : '') +
              (hasNickname && makeModel ? '<small>' + escapeHtml(makeModel) + '</small>' : '') +
            '</span>' +
            '<span class="vehicle-saved-active-option-state">' +
              stateLabel +
              (isSelected ? '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><circle cx="8" cy="8" r="8" fill="#56C742"/><path d="M11.25 5.5L7 9.75L5.25 8" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' : '') +
            '</span>' +
          '</button>';
      }).join("");
    }

    function fillSavedActive(detail) {
      var data = detail || {};
      var vehicles = Array.isArray(data.vehicles) && data.vehicles.length ? data.vehicles : [
        { id: "vehicle-vw-tiguan", brand: "VW", model: "Tiguan", year: "2021", engineName: "1.5 TSI", tire: "215/65R17" },
        { id: "vehicle-toyota-yaris", brand: "Toyota", model: "Yaris", year: "2023", engineName: "1.5 Hybrid", tire: "185/65R15" }
      ];
      activePopupVehicles = vehicles.slice(0, 6);

      var newVehicleId = data.newVehicleId || activePopupVehicles[0].id;
      var newVehicle = activePopupVehicles.find(function (vehicle) {
        return vehicle.id === newVehicleId;
      }) || activePopupVehicles[0];

      pendingActiveVehicleId = data.activeId || newVehicleId;
      vehicleSavedActiveOverlay.setAttribute("data-new-vehicle-id", newVehicle ? newVehicle.id : "");

      if (activeAddedEl) activeAddedEl.textContent = normalizeVehicleLabel(newVehicle) + " eklendi!";
      if (activeSpecEl) activeSpecEl.textContent = normalizeVehicleSpec(newVehicle);
      if (activeCountEl) activeCountEl.textContent = "Garajında artık " + activePopupVehicles.length + " araç var";

      renderSavedActiveOptions();
    }

    document.querySelectorAll("[data-vehicle-saved-active-open]").forEach(function (opener) {
      opener.addEventListener("click", function () {
        fillSavedActive();
        openOverlay(vehicleSavedActiveOverlay);
      });
    });

    vehicleSavedActiveOverlay.addEventListener("click", function (event) {
      if (event.target === vehicleSavedActiveOverlay || event.target.closest("[data-vehicle-saved-active-close]")) {
        closeOverlay(vehicleSavedActiveOverlay);
        return;
      }

      var pickButton = event.target.closest("[data-vehicle-saved-active-pick]");
      if (pickButton) {
        pendingActiveVehicleId = pickButton.getAttribute("data-vehicle-saved-active-pick");
        renderSavedActiveOptions();
        return;
      }

      if (event.target.closest("[data-vehicle-saved-active-continue]")) {
        if (pendingActiveVehicleId) {
          document.dispatchEvent(new CustomEvent("garage:set-active-vehicle", {
            detail: { id: pendingActiveVehicleId }
          }));
        }
        closeOverlay(vehicleSavedActiveOverlay);
      }
    });

    document.addEventListener("garage:vehicle-saved", function (event) {
      var detail = event.detail || {};
      if (Number(detail.totalVehicles || 0) <= 1) return;
      fillSavedActive(detail);
      openOverlay(vehicleSavedActiveOverlay);
    });
  }

  document.addEventListener("keydown", function (event) {
    if (event.key !== "Escape") return;
    document.querySelectorAll(".registration-overlay.is-open").forEach(function (overlay) {
      closeOverlay(overlay);
    });
  });

  document.addEventListener("garage:availability-changed", function (event) {
    var detail = event.detail || {};
    if (detail.available === false) closeGarageOverlays();
  });
})();
